import { render, staticRenderFns } from "./OptionList.vue?vue&type=template&id=d20c5a32&scoped=true"
import script from "./OptionList.vue?vue&type=script&lang=js"
export * from "./OptionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20c5a32",
  null
  
)

export default component.exports